export default __webpack_public_path__ + "static/media/product-details.a56f00ad.jpg";